import React from "react";
import { Alert, Button, Modal } from "react-bootstrap";
import AsyncSelect from "react-select/async";
import AddExtraLessonsForm from "../registration/AddExtraLessonsForm";
import { PendingLessonsTable, ScheduledLessonsTable } from "../lessons/LessonTables";

/**
 * Modal component for managing road test lessons for a selected student.
 */
export default function ManageLessonsModal({
  // Visibility
  showManageLessons,
  onHide,

  // Student & lesson data
  selectedLessonStudent,
  avaliableOptions,
  newLessonsToAdd,
  selectedLessonLocation,
  selectedLessonValue,
  selectedDay,

  // Extra lessons UI state
  showAddLessons,
  showRemoveLessons,
  loading,

  // AddExtraLessonsForm CC fields
  addLessonValidated,
  skipExtraLessonsPayment,
  CCNumber,
  CCFirstName,
  CCLastName,
  CCExpiration,
  CCCode,
  CCAddress,
  CCCity,
  CCState,
  CCZip,
  CCCountry,
  CCLessonsWanted,
  CCLessonsPrice,
  CCErrors,

  // Lesson loaders
  loadOptions,
  loadWalpoleOptions,
  loadBraintreeOptions,

  // Callbacks
  onSetLessonLocation,
  onLessonDateChange,
  onAddLessonDate,
  onDeleteNewLesson,
  onSaveNewLessons,
  onDeleteOldLesson,
  onSkipStudentLessons,
  onShowAddLessons,
  onShowRemoveLessons,
  onRemoveAdditionalLessons,
  onModalInputChange,
  onToggleSkipPayment,
  onAddNewLessons,
}) {
  // Compute derived lesson state
  let lessonsRequired = 0;
  let lessonsScheduled = [];
  let failedScheduledLessons = [];

  if (Object.keys(selectedLessonStudent).length > 0) {
    let matchedPackage = avaliableOptions.filter(
      (x) => x.package === selectedLessonStudent.selectedPackage,
    );
    if (matchedPackage.length === 1) {
      lessonsRequired = parseInt(matchedPackage[0].lessons);
    }

    selectedLessonStudent.fullPricing
      .filter((x) => x.name.includes("Extra Lesson"))
      .map((x) => x.name)
      .map((x) => (lessonsRequired += parseInt(x.split(" ")[0])));

    if (selectedLessonStudent.scheduledLessons) {
      lessonsScheduled = selectedLessonStudent.scheduledLessons;
    }
    if (selectedLessonStudent.failedLessons) {
      failedScheduledLessons = selectedLessonStudent.failedLessons;
    }
  }

  function renderLessonState() {
    return (
      <div>
        {newLessonsToAdd.length > 0 ? (
          <Alert variant="warning">
            There are unsaved values. Please remember to save.
          </Alert>
        ) : null}
        <div>
          <strong>Student</strong>:{" "}
          {selectedLessonStudent.fName + " " + selectedLessonStudent.lName}
        </div>
        <div>
          <strong>Lessons Needed</strong>: {lessonsRequired}
        </div>

        {lessonsScheduled.length + newLessonsToAdd.length < lessonsRequired ? (
          <div>
            <Button
              disabled={selectedLessonLocation === "West Roxbury"}
              onClick={() => onSetLessonLocation("West Roxbury")}
            >
              View West Roxbury Lessons
            </Button>
            <Button
              disabled={selectedLessonLocation === "Walpole"}
              onClick={() => onSetLessonLocation("Walpole")}
            >
              View Walpole Lessons
            </Button>
            <Button
              disabled={selectedLessonLocation === "Braintree - Granite St"}
              onClick={() => onSetLessonLocation("Braintree - Granite St")}
            >
              View Braintree RMV Site Lessons
            </Button>

            {selectedLessonLocation === "West Roxbury" ? (
              <div>
                <div>West Roxbury</div>
                <AsyncSelect
                  key={selectedDay}
                  value={selectedLessonValue}
                  cacheOptions={false}
                  loadOptions={loadOptions}
                  defaultOptions
                  noOptionsMessage={() =>
                    "No lessons avaliable for " + selectedDay + "."
                  }
                  onChange={onLessonDateChange}
                />
                <Button
                  disabled={Object.keys(selectedLessonValue).length === 0}
                  onClick={() => onAddLessonDate()}
                >
                  Add Lesson
                </Button>
              </div>
            ) : null}

            {selectedLessonLocation === "Walpole" ? (
              <div>
                <div>Walpole</div>
                <AsyncSelect
                  key={selectedDay}
                  value={selectedLessonValue}
                  cacheOptions={false}
                  loadOptions={loadWalpoleOptions}
                  defaultOptions
                  noOptionsMessage={() =>
                    "No lessons avaliable for " + selectedDay + "."
                  }
                  onChange={onLessonDateChange}
                />
                <Button
                  disabled={Object.keys(selectedLessonValue).length === 0}
                  onClick={() => onAddLessonDate()}
                >
                  Add Lesson
                </Button>
              </div>
            ) : null}

            {selectedLessonLocation === "Braintree - Granite St" ? (
              <div>
                <div>Braintree - Granite St Site</div>
                <AsyncSelect
                  key={selectedDay}
                  value={selectedLessonValue}
                  cacheOptions={false}
                  loadOptions={loadBraintreeOptions}
                  defaultOptions
                  noOptionsMessage={() =>
                    "No lessons avaliable for " + selectedDay + "."
                  }
                  onChange={onLessonDateChange}
                />
                <Button
                  disabled={Object.keys(selectedLessonValue).length === 0}
                  onClick={() => onAddLessonDate()}
                >
                  Add Lesson
                </Button>
              </div>
            ) : null}
          </div>
        ) : null}
        <br></br>

        <PendingLessonsTable
          lessons={newLessonsToAdd}
          onDelete={onDeleteNewLesson}
          onSave={onSaveNewLessons}
          loading={loading}
        />
        <ScheduledLessonsTable
          scheduledLessons={lessonsScheduled}
          failedLessons={failedScheduledLessons}
          onDelete={onDeleteOldLesson}
        />

        <Button
          size="sm"
          disabled={loading}
          onClick={() => onSkipStudentLessons("syncStudentLessons")}
        >
          Sync Lessons With Lesson Table
        </Button>

        <br></br>
        <br></br>

        <Button
          variant="success"
          disabled={
            selectedLessonStudent.hasOwnProperty("confirmScheduledRegular") &&
            selectedLessonStudent.confirmScheduledRegular === true
          }
          onClick={() => onSkipStudentLessons("confirmScheduledRegular")}
        >
          Confirm On Regular Schedule
        </Button>
        <Button
          variant="danger"
          disabled={
            !selectedLessonStudent.hasOwnProperty("confirmScheduledRegular") ||
            selectedLessonStudent.confirmScheduledRegular === false
          }
          onClick={() => onSkipStudentLessons("undoConfirmScheduledRegular")}
        >
          Undo Regular Schedule Confirm
        </Button>

        <br></br>
        <br></br>

        <Button
          size="sm"
          variant="danger"
          disabled={
            selectedLessonStudent.hasOwnProperty("skipStudentLessons") &&
            selectedLessonStudent.skipStudentLessons === true
          }
          onClick={() => onSkipStudentLessons("skipStudentLessons")}
        >
          Skip Scheduling Lessons
        </Button>
        <Button
          size="sm"
          disabled={
            !selectedLessonStudent.hasOwnProperty("skipStudentLessons") ||
            selectedLessonStudent.skipStudentLessons === false
          }
          onClick={() => onSkipStudentLessons("undoSkipStudentLessons")}
        >
          Undo Skip Scheduling Lessons
        </Button>

        <br></br>
        <br></br>
        <Button
          size="sm"
          disabled={showAddLessons || loading}
          onClick={onShowAddLessons}
        >
          Add Extra Lessons
        </Button>

        <br></br>
        <br></br>
        <Button
          variant="danger"
          size="sm"
          disabled={showRemoveLessons || loading}
          onClick={onShowRemoveLessons}
        >
          Remove Extra Lessons
        </Button>

        <br></br>
        <br></br>

        {showRemoveLessons ? (
          <div>
            <strong>Remove Extra Lessons</strong>
            <table>
              <thead>
                <tr>
                  <th>Lesson Name</th>
                  <th>Lesson Price</th>
                  <th>Options</th>
                </tr>
              </thead>
              <tbody>
                {selectedLessonStudent.fullPricing
                  .filter((x) => x.name.includes("Extra Lesson"))
                  .map((lesson, index) => {
                    return (
                      <tr key={index}>
                        <td>{lesson.name}</td>
                        <td>{lesson.price}</td>
                        <td>
                          <Button
                            variant="danger"
                            onClick={() =>
                              onRemoveAdditionalLessons(lesson, index)
                            }
                          >
                            X
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>

            <br></br>
            <br></br>
          </div>
        ) : null}

        {showAddLessons ? (
          <AddExtraLessonsForm
            loading={loading}
            addLessonValidated={addLessonValidated}
            skipExtraLessonsPayment={skipExtraLessonsPayment}
            CCNumber={CCNumber}
            CCFirstName={CCFirstName}
            CCLastName={CCLastName}
            CCExpiration={CCExpiration}
            CCCode={CCCode}
            CCAddress={CCAddress}
            CCCity={CCCity}
            CCState={CCState}
            CCZip={CCZip}
            CCCountry={CCCountry}
            CCLessonsWanted={CCLessonsWanted}
            CCLessonsPrice={CCLessonsPrice}
            CCErrors={CCErrors}
            onChange={onModalInputChange}
            onToggleSkip={onToggleSkipPayment}
            onSubmit={onAddNewLessons}
          />
        ) : null}
      </div>
    );
  }

  return (
    <Modal
      size="lg"
      show={showManageLessons}
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title id="manage-road-test-lessons">
          Manage Road Test Lessons
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {selectedLessonStudent &&
        Object.keys(selectedLessonStudent).length > 0 ? (
          renderLessonState()
        ) : (
          <div>There are no lessons to render.</div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onHide}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
